import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import TestCaseAssertion from './TestCaseAssertion'
import EditableInput from './EditableInput'
import UploadStepInput from './UploadStepInput'

const StepsAccordion = ({
  testCase,
  handleUpdateStepValue,
  handleUploadStepFile,
  uploadingSteps = {},
  forceEditable = false,
}) => {
  return <Box className='stepsAccordionContainer'>
    <Accordion className='stepsAccordion' defaultExpanded>
      <AccordionSummary className='stepsAccordionSummary' expandIcon={<ExpandMoreIcon/>}>
        <Typography className='stepsAccordionSummaryTitle'>Steps</Typography>
      </AccordionSummary>
      <AccordionDetails className='stepsAccordionContent'>
        <TableContainer className="stepsAccordionTableContainer" component={Paper} elevation={0}>
          <Table className='stepsAccordionTable'>
            <TableHead className='stepsAccordionTableHeader'>
              <TableRow>
                <TableCell className='stepsAccordionTableHeaderCell stepsAccordionIndex'>#</TableCell>
                <TableCell className='stepsAccordionTableHeaderCell'>Step Name</TableCell>
                <TableCell className='stepsAccordionTableHeaderCell'>Test Data</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {testCase?.steps.map((step, index) => (
                <TableRow key={step.id} className='stepsAccordionTableBodyRow'>
                  <TableCell className="stepsAccordionTableBodyCell stepsAccordionIndex">{index + 1}</TableCell>
                  <TableCell className="stepsAccordionTableBodyCell">{step.label}</TableCell>
                  <TableCell className="stepsAccordionTableBodyCell">
                    {(() => {
                      if (!forceEditable && !testCase?.isActive) return ''

                      if (step.type === 'UPLOAD') {
                        return (
                          <UploadStepInput
                            stepId={step.id}
                            value={step.value}
                            uploadMeta={step.options?.upload}
                            onSave={(newValue) => handleUpdateStepValue(step.id, newValue)}
                            onUpload={(file) => handleUploadStepFile?.(step.id, file)}
                            isUploading={Boolean(uploadingSteps[step.id])}
                          />
                        )
                      }

                      if (
                        (step.type === 'TYPE' || step.type === 'SELECT_OPTION') &&
                        step.value !== '<empty_email>' &&
                        step.value !== '<empty_password>'
                      ) {
                        return (
                          <EditableInput
                            key={step.id}
                            value={(() => {
                              if (!step.value) return ''
                              // keep showing tokens like ${EMAIL_RANDOM_DATA} if present
                              if (typeof step.value === 'string' && step.value.startsWith('${') && step.value.endsWith('}')) return step.value
                              return step.role !== 'password_input' && step.value ? (step.value[0] !== '<' ? step.value : '') : ''
                            })()}
                            onSave={(newValue) => handleUpdateStepValue(step.id, newValue)}
                            isSelect={step.type === 'SELECT_OPTION'}
                          />
                        )
                      }

                      return ''
                    })()}
                  </TableCell>
                </TableRow>
              ))}
              <TestCaseAssertion testCase={testCase}/>
            </TableBody>
          </Table>
        </TableContainer>
        { testCase.evaluatuion_conclusions ? (
          <Box
            className="stepsAccordionAIConclusionContainer"
            sx={{
              mt: 2.5,
              pt: 1,
            }}
          >
            <Typography variant="body1" color="primary">
              <span className="stepsAccordionAIConclusionLabel">AI Conclusion: </span>
              {testCase.evaluatuion_conclusions}
            </Typography>
          </Box>
        ) : null }
      </AccordionDetails>
    </Accordion>
  </Box>
}

export default StepsAccordion
